import React from 'react'
import useAuth from '../Hooks/useAuth'

const SideBar = () => {
  const { auth } = useAuth();

  return (
    <div>
    <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel" style={{width: 15 + 'rem'}}>
      <div className="offcanvas-body">
        <ul className="navbar-nav justify-content-end flex-grow-1 pe-3 font-size-4">
          {(auth?.user?.roles !== 0) && <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" aria-current="page" href={(auth?.user?.roles===1) ? `/edit/doctor/${auth?.user.id}` : (auth?.user?.roles===2) ? `/profile`: "#"}>{auth?.user?.roles===2 ? "Profile" : "Edit Profile" }</a>
          </li>}

          <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/list/appointment">Appointments</a>
          </li>

          {(auth?.user?.roles === 0) && <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/doctor/list">Doctors</a>
          </li>}

          {(auth?.user?.roles === 0) && <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/user/list">Users</a>
          </li>}

          {(auth?.user?.roles === 0) && <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/medicine">Medicine</a>
          </li>}
          
          {(auth?.user?.roles === 1) && <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/my/blogs">My Blogs</a>
          </li>}
          
          {(auth?.user?.roles !== 1) &&<li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/list/review">Reviews</a>
          </li>}
          
          <li className="nav-item">
            <a className="btn nav-link btn-light text-start p-2 my-2" href="/settings">Settings</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  )
}

export default SideBar